/**
 * "TIME TO ACT" turn-start popup. Rendered by turnStartOverlayHost (separate React root).
 * Snapshot is frozen at open time; parent BattleUI re-renders must not affect this tree.
 */

import React, { useEffect } from 'react';

const DISPLAY_MS = 2000;

function TurnStartOverlay({ snapshot, onComplete }) {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      onComplete();
    }, DISPLAY_MS);
    return () => window.clearTimeout(timer);
  }, [onComplete]);

  if (!snapshot) return null;

  const {
    turnNumber,
    health,
    intel,
    isMobile,
    turnLabel,
    timeToActText,
    reducedMotion,
  } = snapshot;

  const mobile = Boolean(isMobile);
  const lite = Boolean(reducedMotion);

  return (
    <div
      className={`turn-start-overlay-wrapper${mobile ? ' turn-start-overlay-wrapper--mobile' : ''}${lite ? ' turn-start-overlay-wrapper--lite' : ''}`}
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
        pointerEvents: 'none',
        contain: 'strict',
        isolation: 'isolate',
        transform: 'translateZ(0)',
      }}
      aria-hidden="true"
    >
      <div
        className={`turn-start-overlay-inner${mobile ? ' turn-start-overlay-inner--mobile' : ''}${lite ? ' turn-start-overlay-inner--lite' : ''}`}
      >
        <div className="turn-start-card">
          <img
            src="/images/turnstart2.png"
            alt=""
            decoding="async"
            style={
              mobile
                ? {
                    width: 'min(78vw, 400px)',
                    maxWidth: 'min(78vw, 400px)',
                    height: 'auto',
                    maxHeight: 'min(38vh, 320px)',
                    objectFit: 'contain',
                    display: 'block',
                  }
                : {
                    width: '900px',
                    height: 'auto',
                    maxWidth: '1728px',
                    maxHeight: '972px',
                    objectFit: 'contain',
                    display: 'block',
                  }
            }
          />
          <div className="turn-start-copy">
            {turnNumber != null && turnLabel ? (
              <span className="turn-start-turn-number">{turnLabel}</span>
            ) : null}
            <span className="turn-start-text">{timeToActText}</span>
            <div className="turn-start-resources" aria-hidden="true">
              <div className="turn-start-resource turn-start-resource--health">
                <span className="turn-start-orb turn-start-orb--health" />
                <span className="turn-start-resource-value">{health}</span>
              </div>
              <div className="turn-start-resource turn-start-resource--intel">
                <span className="turn-start-orb turn-start-orb--intel" />
                <span className="turn-start-resource-value">{intel}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(TurnStartOverlay);
